import authReducer, { logout } from "./authReducer";
import loadingReducer from "./loadingReducer";
import menuReducer from "./menuReducer";
import roleReducer from './roleReducer'
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import customizationReducer from "./customizationReducer";
import { rootReducer } from "./rootReducer";
import { clearSelectedProgramDataKey } from "util/programSelection";

// ==============================|| REDUX - MAIN STORE ||============================== //

const rootPersistConfig = {
  key: "rooterp",
  storage,
  blacklist: ["loading"],
};

// const reducer = combineReducers({
//   auth: authReducer,
//   role: roleReducer,
//   menu: menuReducer,
//   loading: loadingReducer,
//   customization: customizationReducer,
// });

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const clearProgramSelectionOnLogout = () => (next) => (action) => {
  const result = next(action);

  if (action.type === logout.type) {
    clearSelectedProgramDataKey();
  }

  return result;
};

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(clearProgramSelectionOnLogout),
});

const persistor = persistStore(store);

export { store, persistor };

